var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.79 43.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.61 18.83 37.61 43.46 0 43.46 0 5.85 26.89 5.85 21.45 11.23 5.37 11.23 5.37 38.09 32.23 38.09 32.23 24.23 37.61 18.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.23,24.23V38.09H5.37V11.23H21.45l5.44-5.38H0V43.46H37.61V18.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.79 5.52 37.61 12.73 32.23 18.14 20.16 30.27 14.55 30.76 14.02 24.63 27.57 11.23 33.01 5.85 38.92 0 44.79 5.52"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModifier);
export default __webpack_public_path__ + "static/media/icon_modifier.37c91e59b26c49fe2c4677a04ab755b3.svg";
export { ForwardRef as ReactComponent };